import React from 'react';
import useUserContext from '../../../../contexts/UserContext/useUserContext';
import LoginForm from './LoginForm';

const Login: React.FC = () => {
     const { signInWithPassword } = useUserContext();

     const handleLogin = async (email: string, password: string) => {
          try {
               const result = await signInWithPassword(email, password);

               if (result) {
                    // Login bem-sucedido - UserContext irá gerenciar a navegação automaticamente
                    // O UserContext já faz a navegação via handleAuthChange
               } else {
                    // Login falhou - erro já foi exibido via showError no UserContext
               }
          } catch (error) {
               // Erro não tratado - erro já foi exibido via showError no UserContext
          }
     };

     return <LoginForm onSubmit={handleLogin} />;
};

export default Login;
